<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fal fa-draw-polygon" id="ico"></i>
		<h1 style="display: inline-block;">Dentro Geocerca</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<h4>Geocerca</h4>
		<p>Especifique un rango de tiempo en el cual desea obtener ubicaciones del vehiculo seleccionado.</p>
		<mat-divider></mat-divider>
		<div class="row mt-3">
			<div class="col-md-3 col-lg-3" style="display: inline-block;">
				<label>Fecha Inicial</label>
				<dx-date-box [(value)]="fechaInicio" type="datetime" [width]="400" displayFormat="yyyy-MM-dd HH:mm:ss"
					style="margin:0 auto;">
				</dx-date-box>
			</div>
			<div class="col-md-3 col-lg-3" style="display: inline-block;">
				<label>Fecha Final</label>
				<dx-date-box [(value)]="fechaFin" type="datetime" [width]="400" displayFormat="yyyy-MM-dd HH:mm:ss"
					style="margin:0 auto;">
				</dx-date-box>
			</div>
			<div class="col-md-3 col-lg-3" style="display: inline-block;">
				<label>Geocercas</label>
				<dx-select-box [dataSource]="geocercas" displayExpr="nombre" valueExpr="id" [(value)]="geocerca"
					[showClearButton]="true" placeholder="Selecciona geocerca">
				</dx-select-box>
			</div>
			<div class="col-md-3 mt-3">
				<button id="boton" type="submit" class="mt-3"
					(click)="obtenerDentroGeocerca(fechaInicio, fechaFin, geocerca)"><i
						class="fal fa-search"></i>Buscar</button>
			</div>
		</div>
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [dataSource]="reporteDentroGeocerca" [showBorders]="true">
							<dxo-paging [pageSize]="10"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxo-export [enabled]="true" fileName="ReportePaso" [allowExportSelectedData]="true">
							</dxo-export>
							<dxi-column caption="Vehiculo" alignment="center" cellTemplate="Ubicar"></dxi-column>
							<dxi-column dataField="placas" caption="Placas" alignment="center"></dxi-column>
							<dxi-column dataField="estado" caption="Estado" alignment="center"></dxi-column>
							<dxi-column dataField="ignicion" caption="Ignición" alignment="center"></dxi-column>
							<dxi-column dataField="fecha" alignment="center" [width]="200">
								<dxo-header-filter [dataSource]="orderHeaderFilter"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Ubicar'" style="text-align: center;">
								<a (click)="ubicarPunto(d.data)">{{d.data.descripcion}}</a>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>

